import { userManagementService } from "./user-management.service";

export class BaseService {
  protected isForbiddenError(error: any): boolean {
    const status = error?.status
      ?? error?.response?.status
      ?? error?.cause?.status;
    return status === 403;
  }

  protected getOrganisatieOrReject(): Promise<{ id: string }> {
    const organisatie = userManagementService.getStoredOrganisatie();
    return organisatie && organisatie.id
      ? Promise.resolve(organisatie)
      : Promise.reject("No organisatie found in localstorage");
  }
}
